<template>
  <div class="user-center">
    <el-card class="user-info-card">
      <div slot="header" class="clearfix">
        <span>个人中心</span>
      </div>
      <el-form :model="userInfo" label-width="120px" label-position="left">
        <el-form-item label="用户名：">
          <span>{{ userInfo.userName }}</span>
        </el-form-item>
        <el-form-item label="昵称：">
          <span>{{ userInfo.nickName }}</span>
        </el-form-item>
        <el-form-item label="邮箱：">
          <span>{{ userInfo.email }}</span>
        </el-form-item>
        <el-form-item label="注册时间：">
          <span>{{ userInfo.regesterTime }}</span>
        </el-form-item>
        <el-form-item label="最后登录时间：">
          <span>{{ userInfo.lastLoginTime }}</span>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getCurrentUser } from '@/api/user'

export default {
  name: 'UserCenter',
  data() {
    return {
      userInfo: {
        userName: '',
        nickName: '',
        email: '',
        regesterTime: '',
        lastLoginTime: ''
      }
    }
  },
  created() {
    this.fetchUserInfo()
  },
  methods: {
    async fetchUserInfo() {
      try {
        const response = await getCurrentUser()
        if (response.data.code === 200) {
          this.userInfo = response.data.data
        } else {
          this.$message.error(response.data.msg || '获取用户信息失败')
        }
      } catch (error) {
        this.$message.error('获取用户信息失败')
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-center {
  max-width: 800px;
  margin: 0 auto;
  
  .user-info-card {
    .el-form {
      padding: 20px;
      
      .el-form-item {
        margin-bottom: 20px;
        
        &:last-child {
          margin-bottom: 0;
        }
        
        span {
          font-size: 14px;
          color: #606266;
        }
      }
    }
  }
}
</style>